import "core-js/modules/es.array.fill.js";
export var popupPortalTokens = {
  sizes: {
    s: {
      maxWidth: 600,
      minWidth: 600,
      padding: {
        mobile: "20px 12px 24px",
        notMobile: "32px 40px 44px"
      },
      borderRadius: {
        mobile: 6,
        notMobile: 4
      }
    },
    m: {
      maxWidth: 800,
      minWidth: 800,
      padding: {
        mobile: "20px 12px 24px",
        notMobile: "32px 44px 44px"
      },
      borderRadius: {
        mobile: 6,
        notMobile: 4
      }
    },
    l: {
      maxWidth: 900,
      minWidth: 900,
      padding: {
        mobile: "20px 12px 24px",
        notMobile: "32px 48px 44px"
      },
      borderRadius: {
        mobile: 6,
        notMobile: 4
      }
    },
    wide: {
      maxWidth: "100%",
      minWidth: "100%",
      padding: {
        mobile: "20px 12px 24px",
        notMobile: "32px 48px 44px"
      },
      borderRadius: {
        mobile: 6,
        notMobile: 4
      }
    }
  },
  defaultSize: "m",
  bgOverlay: function bgOverlay(_ref) {
    var palette = _ref.palette;
    return palette.neutralsBlack.rgba50;
  },
  bgModal: function bgModal(_ref2) {
    var palette = _ref2.palette;
    return palette.neutralsWhite.hex100;
  },
  closeButton: {
    padding: 16,
    color: function color(_ref3) {
      var _color = _ref3.color;
      return _color.fill.icon.base;
    },
    colorHover: function colorHover(_ref4) {
      var color = _ref4.color;
      return color.fill.icon.hover;
    }
  },
  headerMarginBottom: 12,
  actionsMarginTop: 34,
  actionsJustifyContent: "flex-end"
};